import {forwardRef, useEffect, useRef, useState} from "react";
import HomeNavigator from "@/views/Home/HomeNavigator";
import {IconSearchPdfCard} from "@/Icon";
import {getSearchWidth, isMac} from "@/Utility";
import {PAGE_TITLE_MARGIN_TOP, SEARCH_WIDTH} from "@/Const";
import { Input, Spin } from "antd";
import {getImagePathWithTheme, imgPathPerfix, isDarkMode, isStringNullOrEmpty} from "@/utils";
import { t } from "i18next";
import {atomSliderWidth} from "@/App";
import {useAtom} from "jotai";
import {atomIsDragLine} from "@/views/Home/HomeIndex";
import GroupItem from "@/views/Tags/GroupItem";
import {removeGroup} from "@model/tag";
import PropertyGroup from "@/views/Property/PropertyGroup";
import {deleteProperty, getPropertyList} from "@model/Property";
import {ipcInvoke} from "@/common/ipc";

const PageProperty = forwardRef((props,ref)=>{

    const [isSearching,setIsSearching] = useState(false);
    const [searchKey,setSearchKey] = useState('');
    const [arrayGroups,setArrayGroups] = useState([]);

    const [isDragLine,setIsDragLine] = useAtom(atomIsDragLine);
    const [rightSliderWidth,setRightSliderWidth] = useAtom(atomSliderWidth);

    const mSearchKey = useRef('');
    const mLastSearchTimeoutId = useRef<any>(0);
    const txtSearchRef = useRef(null);

    useEffect(() => {
        window.refreshList['refresh_page_property_'] = ()=>{
            refreshProperty();
        }

        refreshProperty();

        return ()=>{
            delete window.refreshList['refresh_page_property_'];
            // ipcInvoke('update-backup-time');
        }
    }, []);

    const arrayDefaultGroup = ()=>{
        return [
            {
                id:'default',
                groupName:'default',
                name:t("System properties"),
                children:[]
            },
            {
                id:'custom',
                groupName:'custom',
                name:t("Custom properties"),
                children:[]
            }
        ]
    }

    /**
     * 刷新属性
     */
    const refreshProperty = ()=>{
        const txtSearch:any = document.getElementById('txt-page-property-input-search-key');
        let szKey = '';
        if (txtSearch){
            szKey = txtSearch.value;
        }
        szKey = szKey.toLowerCase();

        getPropertyList().then(res=>{
            const arrayNew = [...arrayDefaultGroup()];
            for (let i=0;i<res.length;i++){
                if (res[i].groupName == 'default'){
                    if (szKey){
                        if (res[i].name.toLowerCase().includes(szKey)){
                            arrayNew[0].children.push(res[i]);
                        }
                    }else{
                        arrayNew[0].children.push(res[i]);
                    }
                }else if (res[i].groupName == 'custom'){
                    if (szKey){
                        if (res[i].name.toLowerCase().includes(szKey)){
                            arrayNew[1].children.push(res[i]);
                        }
                    }else{
                        arrayNew[1].children.push(res[i]);
                    }
                }
            }
            setIsSearching(false);
            setArrayGroups(arrayNew);
        })
    }

    /**
     * 渲染搜索后缀
     */
    const renderSuffix = ()=>{
        if (isSearching){
            return<>
                <Spin indicator={<img className={'img-16 rotating-image mr-6'}
                                      src={getImagePathWithTheme('indicator_black')}/>} size={'small'}/>
            </>
        }else {
            return <img className='img-mini-small-8 cursor-pointer'
                        style={{display: isStringNullOrEmpty(searchKey) ? "none" : "inherit",marginRight:'6px'}}
                        onClick={() => {
                            setSearchKey('');
                            mSearchKey.current = '';
                            // setArrayGroups([]);
                            setTimeout(()=>{
                                refreshProperty();
                            },100)

                        }}
                        src={imgPathPerfix() + (isDarkMode() ? "close_white_1.png" : "close_black.png")}/>
        }
    }

    return <div style={{
        height: '100vh',
        background: 'var(--background-color-f9fafb)',
        padding: '0px 20px 12px 20px',
        width: `calc(100% - ${rightSliderWidth}px)`,
        pointerEvents: isDragLine ? 'none' : 'all'
    }}>
        <div className={'flex-row-vertical-center'} style={{
            // height: `${HEADER_HEIGHT}px`
            // minHeight:`${HEADER_HEIGHT}px`,
            paddingTop: '7px',
            gap: '12px 22px',//y,x
            flexWrap: 'wrap',
            // overflow:'hidden'
        }}>
            <HomeNavigator margin={'0 0px 0 -4px'} onBeforeBack={() => {

                return false;
            }}/>

            <Input prefix={<IconSearchPdfCard/>}
                   suffix={renderSuffix()}
                   variant={"borderless"}
                   ref={txtSearchRef}
                   className={'input-border'}
                   id={'txt-page-property-input-search-key'}
                   style={{
                       width: getSearchWidth(),
                       height: '32px',
                       marginLeft:'-7px',
                       // backgroundColor: 'var(--input-background-color)'
                   }}
                   placeholder={t('Search properties')} value={searchKey}
                   onChange={(event) => {
                       mSearchKey.current = event.currentTarget.value.toLowerCase();
                       setSearchKey(event.currentTarget.value);

                       setIsSearching(true);
                       clearTimeout(mLastSearchTimeoutId.current);
                       mLastSearchTimeoutId.current = setTimeout(() => {
                           refreshProperty();
                           clearTimeout(mLastSearchTimeoutId.current);
                       }, 1500);
                   }}/>

            <div className={'flex-row-vertical-center'} style={{marginLeft: 'auto'}}>
                <div className='button-max-height newcard-border-gray-style-no-hover flex-center font-size-12'
                     onClick={() => {
                        window.showDialogAddProperty(null);
                     }}
                     style={{marginLeft: '1px', height: '32px', padding: '0 12px', borderRadius: '8px',color:'var(--text-dark-gray-color)'}}>
                    {/*imgPathPerfix() + (isHoverAddTag ? 'add_blue.png' : (isDarkMode() ? 'add_white.png' : 'add_tag_s.png'))*/}
                    <img className='img-mini-small-12'
                         src={getImagePathWithTheme('add_new_property.svg')}/>
                    <span className='ml-6'>{t("New property")}</span>
                </div>
            </div>
        </div>

        {/*标题*/}
        <div className={'flex-row-vertical-center'}
             style={{marginTop: `${PAGE_TITLE_MARGIN_TOP}px`, marginBottom: '1px', minHeight: '32px'}}>
                        <span className='header-title font-family-semi-bold'
                              style={{
                                  display: 'block',
                                  marginTop:'8px',
                              }}>{t('Properties')}</span>
        </div>

        <div style={{height: '20px'}}></div>


        {
            (arrayGroups.length > 0) &&
            <div style={{
                overflow: 'auto',
                height: `${document.body.clientHeight - (isMac() ? 126 : 156)}px`,
                margin: '0 -20px',
                padding: '0 20px'
            }}>
                {
                    arrayGroups.map(p => {
                        return (
                            <PropertyGroup group={p} onEditGroup={(property)=>{

                            }} onTagAction={(szAction,data)=>{
                                if ('edit' == szAction) {
                                    window.showDialogAddProperty(data);
                                }else if ('delete' == szAction) {
                                    window.showMessageBox(t("Delete property"), t("SureToDeleteProperty"), t("Cancel"), t("Delete"), null, () => {
                                        deleteProperty(data.id).then(res=>{
                                            refreshProperty();
                                        })
                                    })
                                }else if ('relatedLibrary' == szAction){
                                    window.showDialogRelatedProperty(data,()=>{

                                    });
                                }
                            }}/>
                        )
                    })
                }
            </div>
        }

    </div>
})


export default PageProperty;




























